import { Search } from '@material-ui/icons';
import React from 'react';
import styles from './SearchBox.module.scss';

function SearchBox({ placeholder, handleChange }) {
	return (
		<div className={styles.searchBar}>
			<Search className={styles.search_icon} />
			<input
				id='search-bar'
				type='text'
				placeholder={placeholder}
				onChange={handleChange}
				data-testid='searchBar'
			/>
		</div>
	);
}

export default SearchBox;
